module.exports = __webpack_public_path__ + "img/grammar-1-en.ea243174.png";